import type { CollectionDto, CollectionModel } from '../../data-layer/collections/types';

export const toCollectionsModel = (collectionDto: CollectionDto): CollectionModel => ({
    id: collectionDto.id,
    url: `/collections/${collectionDto.id}`,
    displayName: collectionDto.display_name,
    numberOfPosts: collectionDto.number_of_posts,
    previewItems: collectionDto.preview_items.map((content) => {
        if (content.type === 'image') {
            return {
                id: content.id,
                type: 'image',
                media: content.media,
            };
        }

        return {
            id: content.id,
            type: 'video',
            media: content.media.map((file) => ({
                url: file.url,
                width: file.width,
                height: file.height,
                firstFrameUrl: file.first_frame_url,
            })),
        };
    }),
    modifiable: collectionDto.modifiable,
    defaultCollection: collectionDto.default_collection,
    isPublic: collectionDto.is_public,
    sharingUrl: collectionDto.sharing_url,
    author: collectionDto.author
        ? {
              id: collectionDto.author.id,
              displayName: collectionDto.author.display_name,
              avatarUrl: collectionDto.author.avatar_url,
          }
        : undefined,
    status: collectionDto.status,
    isLiked: collectionDto.is_liked,
    likes: collectionDto.likes,
    footerData: collectionDto.footer_data
        ? {
              feedButtonText: collectionDto.footer_data.feed_button_text,
          }
        : undefined,
});
